import { render, staticRenderFns } from "./BookVideo.vue?vue&type=template&id=b24f52bc&scoped=true&"
import script from "./BookVideo.vue?vue&type=script&lang=js&"
export * from "./BookVideo.vue?vue&type=script&lang=js&"
import style0 from "./BookVideo.vue?vue&type=style&index=0&id=b24f52bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f52bc",
  null
  
)

export default component.exports